<div class="row" *ngIf="!sessionService.isAuthenticated()">
    <div class="col-lg-1"></div>
    <div class="col-md-12 col-lg-5">
        <div class="row justify-content-lg-center white-panel">
            <div class="col-md-12 col-lg-11">
                <aside class="px-3 pb-4 text-start" aria-labelledby="login-promotion-heading">
                    <h2 class="login-promotion-panel__heading fw-semibold mb-4 text-center text-primary" id="login-promotion-heading">Take Professional Growth Further with Peer-to-Peer Observations</h2>
                    <p>Educators can use <span class="text-nowrap"><span class="login-promotion-panel__badge rounded-pill">New</span><strong class="text-primary">Custom Supervision</strong></span> to complete peer observations, exchange focused feedback, and collaborate - all within PAETEP.</p>
                    <div class="border-start border-3 border-primary bg-light mb-4 ps-3 py-2">
                        <p class="mb-1">Ideal for:</p>
                        <ul class="mb-0">
                            <li>Peer Coaching Initiatives</li>
                            <li>Instructional Coaching Cycles</li>
                            <li>Teacher Mentoring Programs</li>
                        </ul>
                    </div>
                    <p class="mb-0 text-center">
                        <a class="btn btn-primary px-4" href="https://edulinksolutions.com/contact/">Contact Us About Custom Supervision</a>
                    </p>
                </aside>
            </div>
        </div>
    </div>
    <div class="col-md-12 col-lg-5">
        <div class="row justify-content-lg-center white-panel">
            <div class="col-md-12 col-lg-10">
                <ui-view name="login-content"></ui-view>
            </div>
        </div>
    </div>
    <div class="col-lg-1"></div>
</div>
